type VipTagProps = React.HTMLAttributes<HTMLDivElement>
import Icon from '@/assets/icons'
import classnames from 'classnames/bind'
import styles from './style.module.scss'

const cx = classnames.bind(styles)

const VipTag = ({ className, ...props }: VipTagProps) => {
  return (
    <div className={cx('vip-tag', className)} {...props}>
      <div className={cx('vip-tag__icon')}>
        <Icon.Diamond />
      </div>
      VIP
    </div>
  )
}

export default VipTag
